export const getByID = <T extends { id: string }>(id: string | null, collection: T[]) =>
    collection.find((item) => item.id === id);

export const takePage = <T>(pageSize: number, pageNumber: number, list: T[]) => {
    const start = (pageNumber - 1) * pageSize;
    const end = start + pageSize;
    return list.slice(start, end);
};
